import { connect } from 'react-redux';
import AddReview from './AddReview';
import {
  setStarRating,
  setReview,
  setSubmissionStatus,
  responseReceived,
  setReviewFlowState,
  setCopyStatus,
  responseError,
  setGooglePlaceUrl,
  setHasRecommendedValue,
} from '../../actions/addReview';
import { receiveLocation } from '../../actions/location';
import { noOp } from '../../actions';
import { apiGetDispatchable, apiPostDispatchable, apiGetJson } from '../../core/dapi';
import { getDapiGoogleReviewUrl } from '../../core/dapi/tracking';
import { getPublicBookingById } from '../../core/dapi/newBooking';
import { getSolvAndUclMergedLocationUrl } from '../../core/dapi/location';
import { getReviewPostUrl, getNpsPostUrl } from '../../core/dapi/addReview';
import { convertCamelToSnakeCase } from '../../core/util/object';
import history from '../../core/history';
import {
  ADD_REVIEW_INITIAL,
  ADD_REVIEW_TO_SOLV,
  QueryParamFlowType,
  queryParamFlowTypes,
} from '../../constants/index';
import { setPastBooking } from '../../actions/pastBookings';
import { starRatingUpdated } from '../../ducks/leaveAReview';

const mapStateToProps = (
  state: any,
  props: { bookingId: string; queryParamFlowType?: QueryParamFlowType }
) => {
  const { bookingId } = props;
  const { googleUrl } = state.addReview;

  let initialReviewState = ADD_REVIEW_INITIAL;

  if (
    (props.queryParamFlowType && queryParamFlowTypes.includes(props.queryParamFlowType)) ||
    !googleUrl
  ) {
    initialReviewState = ADD_REVIEW_TO_SOLV;
  }

  return {
    starRating: state.addReview.starRating,
    isSubmitting: state.addReview.submitting,
    responseReceived: state.addReview.responseReceived,
    flowState: state.addReview.flowState || initialReviewState,
    persistentStateLoaded: state.runtime.persistentStateLoaded,
    review: state.addReview.review,
    copyStatus: state.addReview.copyStatus,
    location: state.location,
    error: state.addReview.error,
    googleUrl,
    leaveAReview: state.leaveAReview,
    hasRecommendedClinic: state.addReview.hasRecommendedClinic,
    booking: state.pastBookings[bookingId],
    flowType: props.queryParamFlowType || state.location.reviewFlowType,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  handleRatingChange: (newRating: any) => dispatch(setStarRating(newRating)),
  handleHasRecommendedClinicChange: (recommendation: any) =>
    dispatch(setHasRecommendedValue(recommendation)),

  submitReview: (form: any, dispatchResponse = true) => {
    // star rating is already in state so we don't need to set it again
    dispatch(setReview(form.review));
    if (dispatchResponse) {
      dispatch(setSubmissionStatus(true));
    }

    const handleSuccess = () => (dispatchResponse ? dispatch(responseReceived()) : () => {});
    const handleError = (e: any) => (dispatchResponse ? dispatch(responseError(e)) : () => {});

    const postData = convertCamelToSnakeCase(form);
    postData.last_message_timestamp = 'NOW()';
    postData.review_date = 'NOW()';
    postData.rating_date = 'NOW()';

    apiPostDispatchable(getReviewPostUrl(), postData, handleSuccess, handleError)(dispatch);
  },

  submitNps: (form: any, dispatchResponse = true) => {
    const postData = convertCamelToSnakeCase(form);
    dispatch(apiPostDispatchable(getNpsPostUrl(), postData, noOp, noOp));
  },

  setFlowState: (state: any) => dispatch(setReviewFlowState(state)),
  setCopyStatus: (value: any) => dispatch(setCopyStatus(value)),

  getBooking: (bookingId: any) => {
    const onSuccess = (response: any) => {
      apiGetJson(getDapiGoogleReviewUrl(bookingId))
        .then((r: any) => dispatch(setGooglePlaceUrl(r.data)))
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
        .catch(() => dispatch(setGooglePlaceUrl()));
      apiGetJson(getSolvAndUclMergedLocationUrl(response.location_id))
        .then((r: any) => dispatch(receiveLocation(r.data)))
        .catch((e: any) => dispatch(receiveLocation(e)));
      return dispatch(setPastBooking(response));
    };

    const onError = (e: any) => history.push('/404');
    const bookingUrl = getPublicBookingById(bookingId);

    apiGetDispatchable(bookingUrl, onSuccess, onError)(dispatch);
  },

  onStarChange: (update: any) => dispatch(starRatingUpdated(update)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReview);
